import { useEffect } from 'react';
import { useStepsStore } from '../stores/StepsStore';
import AppService from '../services/AppService';

const Step_AfterGCL = () => {
  const { subscription_starts_at, subscriptionPrice, deviceId, orderId, secureHash, goToVerifyStep, selectedVariantID, selectedPlanTitle, vat_plans, no_vat_plans} = useStepsStore();

  useEffect(() => {
    const appsService = new AppService((window as any).shop_domain);
    appsService.isGCLCompleted(deviceId, orderId, secureHash).then(isCompleted => {
      if(!isCompleted) {
        goToVerifyStep();
      }
    });
  }, []);
  
  return (
    <>
      <div className="simple-form">
        <h2 className='ncf-title'>Please Confirm the Following</h2>
       <span className='ncf-subtitle'>You have set up a direct debit with Careline365.</span>
        <p className='step-explain'>A payment of £{subscriptionPrice} will be taken from your account on { subscription_starts_at } for your ongoing subscription.</p>
        <div className='ts-and-cs-box'>
            By clicking 'Confirm Now', I confirm that I am over 18, and that I have read and accept the <a href='https://careline.co.uk/pages/terms-and-conditions' target='_blank'>Terms and Conditions</a> and the <a href='https://careline.co.uk/policies/privacy-policy' target='_blank'>Privacy Policy</a>.
        </div>
      </div>
    </>
  );
};

export default Step_AfterGCL;